// Central status → colour / label mapping for the redesigned reservations dashboard.
// Status string values in use across the reservation feature:
//   pending-for-approval | confirmed | completed | auto-completed |
//   approval-timeout | no-show | cancelled
//
// `labelKey` maps to i18n `reservationsV2.status.<labelKey>` so status text is localized.
// `color` is the accent/foreground, `bg` the soft chip/background fill.

import type { TFunction } from 'i18next';

export interface StatusMeta {
  labelKey: string;
  color: string;
  bg: string;
}

export const STATUS_META: Record<string, StatusMeta> = {
  'confirmed':            { labelKey: 'confirmed',     color: '#2E7D32', bg: '#E7F4EC' },
  'pending-for-approval': { labelKey: 'pending',       color: '#B7791F', bg: '#FBF1DC' },
  'completed':            { labelKey: 'completed',     color: '#2C5D8A', bg: '#E7F0F8' },
  'auto-completed':       { labelKey: 'autoCompleted', color: '#2C5D8A', bg: '#E7F0F8' },
  'no-show':              { labelKey: 'noShow',        color: '#C6544C', bg: '#FBE9E7' },
  'approval-timeout':     { labelKey: 'timeout',       color: '#8A8177', bg: '#EFEBE7' },
  'cancelled':            { labelKey: 'cancelled',     color: '#8A8177', bg: '#EFEBE7' },
};

const FALLBACK: StatusMeta = { labelKey: 'unknown', color: '#8A8177', bg: '#EFEBE7' };

export const getStatusMeta = (status: string): StatusMeta => STATUS_META[status] || FALLBACK;

// Localized status label. `t` is the react-i18next translate fn.
export const getStatusLabel = (status: string, t: TFunction): string => t(`reservationsV2.status.${getStatusMeta(status).labelKey}`);
